import type { InputHTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "onChange"> {
  label: ReactNode;
  onChange?: (checked: boolean) => void;
}

/** 标签写开启后的效果："仅允许 TLS"。 */
export function Switch({ label, className, onChange, ...rest }: SwitchProps) {
  return (
    <label className={cx("ax-switch", className)}>
      <input type="checkbox" role="switch" onChange={(e) => onChange?.(e.target.checked)} {...rest} />
      <span className="ax-switch-track" />
      {label}
    </label>
  );
}
